import { markHomeLinks } from './visit'

/** The language switcher: toggle open/close, and set the lang cookie when a locale link is clicked. */
export function wireSwitcher(lang: HTMLElement) {
  const toggle = lang.querySelector('button')!
  function set(open: boolean) {
    lang.classList.toggle('open', open)
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false')
  }
  toggle.addEventListener('click', (e) => {
    e.stopPropagation()
    set(!lang.classList.contains('open'))
  })
  const links = lang.querySelectorAll<HTMLAnchorElement>('a[hreflang]')
  links.forEach((a) => {
    a.addEventListener('click', () => {
      const locale = a.getAttribute('hreflang')
      if (locale) {
        // Persistent first-party cookie, exempt from consent (WP29 Opinion 04/2012 §3.6).
        document.cookie = `lang=${locale}; path=/; max-age=31536000; SameSite=Lax`
      }
    })
  })
  // Each locale link is a link to the home page in another language: mark it so
  // the switch skips the intro and opens on the section the reader is on.
  markHomeLinks(links)
  document.addEventListener('click', () => set(false))
}
